module.exports = __webpack_public_path__ + "img/introduce_content_1_ug.e8484dbe.png";